import { useTranslation } from "react-i18next";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import BackLink from "../ui/BackLink/BackLink";
import { kanjiMathematicsEntries } from "../../consts/kanjiMathematics";
import { useLocalizedPath } from "../../i18n/localizedPath";
import KanjiMathematicsCard from "./KanjiMathematicsCard";
import styles from "./kanjiMathematicsPage.module.scss";

export default function KanjiMathematicsPage() {
    const { t, i18n } = useTranslation("kanjiMathematicsPage");
    const lp = useLocalizedPath();
    const isPt = i18n.language === "pt";
    const currentPath = isPt ? "/pt/kanji-mathematics" : "/kanji-mathematics";

    return (
        <div className={styles.page}>
            <Seo title={t("seoTitle")} description={t("seoDescription")} path={currentPath} lang={isPt ? "pt-PT" : undefined} />
            <Header />
            <main className={styles.main}>
                <BackLink to={lp("/learn")} label={t("common:backLink.toLearn")} className={styles.backLink} />
                <section className={styles.intro} aria-labelledby="kanji-mathematics-title">
                    <p className={styles.eyebrow}>{t("eyebrow")}</p>
                    <h1 id="kanji-mathematics-title">{t("title")}</h1>
                    <p className={styles.subtitle} lang="ja">{t("subtitle")}</p>
                    <p className={styles.description}>{t("description")}</p>
                </section>

                <aside className={styles.howToRead} aria-labelledby="kanji-mathematics-how-to-read">
                    <h2 id="kanji-mathematics-how-to-read">{t("howToRead.title")}</h2>
                    <p>{t("howToRead.body")}</p>
                </aside>

                <ul className={styles.list} aria-label={t("listLabel")}>
                    {kanjiMathematicsEntries.map((entry) => (
                        <li key={entry.id}>
                            <KanjiMathematicsCard entry={entry} />
                        </li>
                    ))}
                </ul>
            </main>
            <Footer />
        </div>
    );
}
